import * as angular from 'angular';

import { MenuComponent } from '../menu/menu.component';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { EventQueueService } from '../shared/utils/AppEventType';
import { ContentOverlayComponent } from '../shared/ui/content-overlay/content-overlay.component';
import { ProjectDisplayContainerComponent } from '../project-display/feature/project-display-container/project-display-container.component';
import { KeywordsService } from '../project-display/utils/keywords.service';
import { AssetAnalysisChartComponent } from '../assets/ui/asset-analysis-chart';
import { RecentlyAddedAssetsContainerComponent } from '../assets/feature/eic-recently-added-assets-container/recentlyAddedAssetsContainer.component';



export const homeModule = angular.module('main', ['EICDataStream3.config', 'ui.router'])
  .directive('appMenu',
    downgradeComponent({
      component: MenuComponent
    }) as angular.IDirectiveFactory
  )
  // downgrade the content overay so it can be used in the angularJS index.html , outputs: ['totalCountEvent']
  .directive("contentOverlay", downgradeComponent({ component: ContentOverlayComponent } as any))

  // downgrade the projectDisplay component so it can be called from AngularJS
  .directive("appProjectDisplayContainer", downgradeComponent({ component: ProjectDisplayContainerComponent } as any))

  // Downgrade the asset analysis chart so it can be used in AngularJS templates/widgets
  .directive("eicAssetAnalysisChart", downgradeComponent({ component: AssetAnalysisChartComponent } as any))

  // Downgrade the recently-added-assets smart component so it can be used in AngularJS templates/widgets
  .directive("eicRecentlyAddedAssetsContainer", downgradeComponent({ component: RecentlyAddedAssetsContainerComponent } as any))

  // Downgrade the EventQueueService so it can be used in the transition hook
  .factory('EventQueueService', downgradeInjectable(EventQueueService) as any)

  // Downgrade the Anggular replacement for the KeyWord Service so it can continue to be used in AngularJS
  .factory('keywordsService', downgradeInjectable(KeywordsService) as any);